import React, { useEffect } from "react";
import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
        ticketHeader: {
                display: "flex",
                background: theme.palette.total,
                flex: "none",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                // Altura automática conforme conteúdo
                alignItems: "center",
                justifyContent: "flex-start",
            paddingTop: 2,
            paddingBottom: 2,
                [theme.breakpoints.down("sm")]: {
                    // mantém automático no mobile também
                },
            },
      backButton: {
        minWidth: "40px",
    padding: "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      backIcon: {
        fontSize: "25px",
      },
            contentWrapper: {
                display: "flex",
                alignItems: "center",
                flex: 1,
                marginLeft: "-20px",
                // Desktop: conteúdo lado a lado
                flexDirection: "row",
                // Mobile: empilhar TicketInfo e ações, centralizando os botões abaixo
                [theme.breakpoints.down("sm")]: {
                    flexDirection: "column",
                    alignItems: "stretch",
                    gap: 4,
                },
            },
      
      
}));

const TicketHeader = ({ loading, children }) => {
    const classes = useStyles();
    const history = useHistory();

    const handleBack = () => {
        history.push("/tickets");
    };


	//ao apertar tecla "ESC" na conversa ela sai daquele atendimento.
	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === "Escape") {
				handleBack();
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [history]);

    return (
        <>
            {loading ? (
                <TicketHeaderSkeleton />
            ) : (
                <Card square className={classes.ticketHeader}>
                    <Button 
                        color="primary" 
                        onClick={handleBack} 
                        className={classes.backButton}
                    >
                        <ArrowBackIos className={classes.backIcon} />
                    </Button>
                    <div className={classes.contentWrapper}>
                        {children}
                    </div>
                </Card>
            )}
        </>
    );
};

export default TicketHeader;
